import { Navigate, Outlet } from "react-router-dom";

import { useAuth } from "../../providers/auth";
import { usePartnerData } from "../../providers/partnerData";

const RoutePrivate = () => {
  const { token } = useAuth();
  const { partnerUrl } = usePartnerData();

  return token ? <Outlet /> : <Navigate to={`/${partnerUrl}/login`} />;
};

export default RoutePrivate;
